export default (function () {
    var services = {};
    var setterGetter = function (newServices) {
        if (newServices === void 0) { newServices = undefined; }
        if (newServices) {
            Object.assign(services, newServices);
        }
        return services;
    };
    setterGetter.clear = function () {
        return Object.keys(services).forEach(function (key) { return delete services[key]; });
    };
    return setterGetter;
});
//# sourceMappingURL=services.js.map